import React from 'react';

export default function TopRightControls({ lang, onLangChange, onToggleTheme, theme, userLabel, onLogout, onFullscreen, fullscreenLabel }) {
  return (
    <>
      {onFullscreen ? (
        <button type="button" className="fr-button" onClick={onFullscreen}>
          {fullscreenLabel || 'Pantalla completa'}
        </button>
      ) : null}

      <select className="fr-select" value={lang} onChange={(e) => onLangChange(e.target.value)} aria-label="Idioma" style={{ width: 130 }}>
        <option value="es">🌎 ES</option>
        <option value="en">🌎 EN</option>
        <option value="pt">🌎 PT</option>
      </select>

      <button type="button" className="fr-iconButton" onClick={onToggleTheme} aria-label="Cambiar tema">
        {theme === 'dark' ? '☀️' : '🌙'}
      </button>

      <button type="button" className="fr-iconButton" aria-label="Notificaciones">
        🔔
      </button>

      {userLabel ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span aria-hidden>👤</span>
          <span style={{ fontSize: 13, fontWeight: 800, maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{userLabel}</span>
          {onLogout ? (
            <button type="button" className="fr-button" onClick={onLogout}>
              Salir
            </button>
          ) : null}
        </div>
      ) : null}
    </>
  );
}
